import { onboardingMessages } from '../assets';
import { type OnboardingMessages } from '../models';

export const getOnboardingMessages = (onboardingMessage: OnboardingMessages) => {
	return onboardingMessages[onboardingMessage];
};
